import { checkIsEmerson } from "@shared/hooks/useCheckIsEmerson/checkIsEmerson";
import { isTest, isDevelopment } from "@shared/utils/fullscriptEnv/fullscriptEnv";

const ServiceWorker = () => {
  const isEmerson = checkIsEmerson();

  // Don't register service worker in emerson as it's hosted behind a different load balancer
  // It's also unlikely that they will be crossing between fullscript and emerson
  // If they do, then assets might not be preloaded, not the end of the world
  if (isDevelopment() || isTest() || isEmerson) return null;

  const serviceWorkerRegisterer = () => {
    return `
      if ("serviceWorker" in navigator) {
        window.addEventListener("load", function() {
          navigator.serviceWorker
            .register("/service-worker.js")
            .catch(function(err) {
              console.log("ServiceWorker registration failed: ", err);
            });
        });
      }`;
  };

  return (
    <script
      data-testid="service-worker"
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{ __html: serviceWorkerRegisterer() }}
    />
  );
};

export { ServiceWorker };
